import React, { isValidElement } from 'react';
import { TabGroupContainer } from './Tab.styled';
import type { TabGroup as TabGroupProps, Tab } from './types';

/** @deprecated Please use ui/tabsGroup instead for the preferred tab group implementation */
export const TabGroup = ({ selectedTab, onTabChange, children, ...otherProps }: TabGroupProps) => {
  return (
    <TabGroupContainer role="tablist" {...otherProps}>
      {React.Children.toArray(children).map((node) =>
        isValidElement<Tab>(node)
          ? React.cloneElement<Tab>(node, {
              isSelected: node.props.id === selectedTab,
              key: node.props.id,
              onClick: () => {
                (node as unknown as Tab).onClick?.();

                if (onTabChange) {
                  onTabChange(node.props.id);
                }
              },
              ...node.props,
            })
          : null,
      )}
    </TabGroupContainer>
  );
};
